import { getTranslationNamespace } from '../../helpers/getTranslationNamespace'

const TRANSLATION_NAMESPACE = getTranslationNamespace('-step')

export const TRANSLATION_KEYS = {
  confirmChangeStep: {
    title: `${TRANSLATION_NAMESPACE}--confirm-change-step--title`,
    message: `${TRANSLATION_NAMESPACE}--confirm-change-step--message`,
    apply: `${TRANSLATION_NAMESPACE}--confirm-change-step--apply`,
    discard: `${TRANSLATION_NAMESPACE}--confirm-change-step--discard`,
    cancel: `${TRANSLATION_NAMESPACE}--confirm-change-step--cancel`,
  },
  confirmCategorySwitchOff: {
    title: `${TRANSLATION_NAMESPACE}--confirm-category-switch-off--title`,
    apply: `${TRANSLATION_NAMESPACE}--confirm-category-switch-off--apply`,
    cancel: `${TRANSLATION_NAMESPACE}--confirm-category-switch-off--cancel`,
  },
  disabledCategoryWarning: {
    title: `${TRANSLATION_NAMESPACE}--disabled-category-warning--title`,
    ok: `${TRANSLATION_NAMESPACE}--disabled-category-warning--ok`,
  },
}
